import { render, staticRenderFns } from "./ArticleSerialNumberComponent.vue?vue&type=template&id=2e0048e3&scoped=true&"
import script from "./ArticleSerialNumberComponent.vue?vue&type=script&lang=js&"
export * from "./ArticleSerialNumberComponent.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSerialNumberComponent.vue?vue&type=style&index=0&id=2e0048e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0048e3",
  null
  
)

export default component.exports